import { h } from 'preact'
import * as firebase from 'firebase'
import FirebaseComponent from './FirebaseComponent'
import moment from 'moment'
import { route } from 'preact-router'
import SignInWithFacebook from './SignInWithFacebook'

class SignUp extends FirebaseComponent {
  constructor() {
		super()

    this.state = {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      message: '',
      loading: false
    }

    this.register = this.register.bind(this)
    this.handleValueChange = this.handleValueChange.bind(this)
    this.loadingSpinner = this.loadingSpinner.bind(this)
  }

  handleValueChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  loadingSpinner() {
    if (this.state.signingIn) return <i className="fa fa-spinner fa-spin" style={{ 'font-size': '24px' }}></i>
  }

  register() {
    this.setState({ loading: true })

    firebase.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
      .then(user => {
        const defaultProfileImage = 'https://s3.amazonaws.com/oil-and-gas-organiser-images/images/simple_logo.png'

        firebase.database().ref(`accounts/${user.uid}`).set({ registeredAt: moment(new Date()).format() })
        firebase.database().ref(`profiles/${user.uid}`).set({
					firstName: this.state.firstName,
					lastName: this.state.lastName,
					profileImage: defaultProfileImage,
					email: this.state.email
				})

        this.setState({ loading: false })
        route("/")
      })
      .catch(error => {
        const message = error.message
        this.setState({ message, loading: false })
      })
  }

  render() {
    return (
      <div class='signin-form'>
          <img src="https://s3.amazonaws.com/oil-and-gas-organiser-images/images/simple_logo.png" alt="OAGO" />
          <h3 className="welcome-back">Register for OAGO!</h3>
          { this.loadingSpinner() }
          <div class="form-group">
            <span>{this.state.message}</span>
            <input name="email" placeholder="Email" type="text" class="form-control" value={this.state.email} onChange={this.handleValueChange} />
            <input name="password" placeholder="Password" type="password" class="form-control" value={this.state.password} onChange={this.handleValueChange} />
					  <input name="firstName" placeholder="First Name" type="text" class="form-control" value={this.state.firstName} onChange={this.handleValueChange} />
					  <input name="lastName" placeholder="Last Name" type="text" class="form-control" value={this.state.lastName} onChange={this.handleValueChange} />
            <button class="btn btn-sm btn-primary btn-block" onClick={this.register}>REGISTER</button>
         </div>
         <div className="form-group">
           <SignInWithFacebook buttonText="Register with Facebook"/>
         </div>
         <div className="form-group">
          <br/><br/>
          <small>By signing into OAGO you agree to the <span> </span>
          <a onClick={e => { e.preventDefault(); route('/terms-and-conditions') }}>Terms and Conditions</a>,<span> </span>
          <a onClick={e => { e.preventDefault(); route('/cookie-policy')}}>Cookie</a> and <a onClick={e => { e.preventDefault(); route('/privacy-policy')}}>Privacy</a> polices.</small>
        </div>
        <br/>
        <span>
          <a href="https://itunes.apple.com/gb/app/oago/id1320515823?mt=8"><img style={{ width: 130 }} src="/app-store.svg" alt="app-store-icon" /></a>
          <a href="https://play.google.com/store/apps/details?id=co.uk.oago.OAGO&hl=en"><img style={{ width: 160 }} src="/google-play-badge.svg" alt="google-play-icon" /></a>
        </span>
      </div>
    );
  }
}

export default SignUp



// WEBPACK FOOTER //
// ./src/SignUp.js